import React from "react";
import ComicBase from "../../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="La Viuda De Mi Vecina Capítulo 54 – Rose Blue 3D"
      portada="https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-027-scaled.webp"
     paginas={[
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-001-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-002-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-003-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-004-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-005-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-006-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-007-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-008-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-009-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-010-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-011-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-012-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-013-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-014-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-015-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-016-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-017-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-018-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-019-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-020-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-021-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-022-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-023-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-024-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-025-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-026-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-027-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-028.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-029-scaled.webp",
  "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-030-scaled.webp"
]}
      sugeridos={[]}


      info={{
       grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
      }}
    />
  );
}

export const infoManga = {
  titulo: "La Viuda De Mi Vecina Capítulo 54 – Rose Blue 3D",
  portada: "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-027-scaled.webp",
  reverso: "https://es.fsicomics.com/wp-content/uploads/2026/05/la-viuda-de-mi-vecina-capitulo-54-rose-blue-3d-025-scaled.webp",
   fecha:"2026-05-17",


  info: {
       grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
  },
};
